import { render, staticRenderFns } from "./VideosSection.vue?vue&type=template&id=ebee134c&"
import script from "./VideosSection.vue?vue&type=script&lang=js&"
export * from "./VideosSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports